import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_warning_circle_red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-77afe4da")

_pushScopeId("data-v-77afe4da")
const _hoisted_1 = { class: "adjustment-weight-guide" }
const _hoisted_2 = { class: "flex items-center gap-2 text-xs font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 h-4",
  alt: "warning"
}, null, -1)
const _hoisted_4 = { class: "flex items-center gap-2 text-xs text-red-lp-100" }
const _hoisted_5 = {
  key: 0,
  class: "suporting-document-guidline"
}
const _hoisted_6 = { class: "w-full bg-white overflow-x-auto" }
const _hoisted_7 = { class: "flex flex-row w-full gap-x-4 items-start p-3" }
const _hoisted_8 = { class: "flex flex-row gap-x-4" }
const _hoisted_9 = { class: "adjustment-weight-item" }
const _hoisted_10 = { class: "photo-guide-image" }
const _hoisted_11 = { class: "photo-guide-description" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "w-px self-stretch shrink-0 bg-gray-lp-1500" }, null, -1)
const _hoisted_13 = { class: "adjustment-weight-item" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", {
    class: ["adjustment-weight-panel border", [
      _ctx.isMandatoryUploadProofAdjust
        ? 'border-red-lp-2400'
        : 'border-gray-lp-3004'
    ]]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("button", {
        type: "button",
        class: "flex items-center justify-between w-full",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClick(!_ctx.showViewAdjustment)))
      }, [
        _createVNode("span", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.shipment.additionalWeight.title")), 1)
        ]),
        _createVNode("span", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.$t("bookingV4.shipment.additionalWeight.collapsedButton")) + " ", 1),
          _createVNode("img", {
            src: 
              require(`@/app/ui/assets/svg/${
                _ctx.showViewAdjustment ? 'chevron-down-red' : 'chevron-up-red'
              }.svg`)
            ,
            class: "w-4 h-4",
            alt: "chevron"
          }, null, 8, ["src"])
        ])
      ]),
      (!_ctx.showViewAdjustment)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_5, null, 512)), [
            [_directive_sanitize_html, _ctx.$t('bookingV4.shipment.additionalWeight.content')]
          ])
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.photoGuides, (photos, index) => {
            return (_openBlock(), _createBlock("div", { key: index }, [
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("img", {
                    src: require(`@/app/ui/assets/svg/${photos.source}.svg`),
                    alt: "result-image"
                  }, null, 8, ["src"])
                ]),
                _withDirectives(_createVNode("p", _hoisted_11, null, 512), [
                  [_directive_sanitize_html, photos.desc]
                ])
              ])
            ]))
          }), 128))
        ]),
        _hoisted_12,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (_, index) => {
          return (_openBlock(), _createBlock("div", { key: index }, [
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_UploadImageTiny, {
                title: _ctx.photoDescription(index),
                accept: "image/jpg, image/jpeg, image/png, application/pdf",
                modelValue: _ctx.attachmentImage[index],
                "onUpdate:modelValue": ($event: any) => (_ctx.attachmentImage[index] = $event),
                defaultImage: _ctx.attachmentImage[index],
                maxSize: 5,
                titleSize: "12",
                onUpload: _ctx.onUpload,
                onRemove: _ctx.onRemove,
                multipleIndex: index
              }, null, 8, ["title", "modelValue", "onUpdate:modelValue", "defaultImage", "onUpload", "onRemove", "multipleIndex"])
            ])
          ]))
        }), 128)),
        (_ctx.proofPhotos.length < _ctx.maxPhoto)
          ? (_openBlock(), _createBlock(_component_Icons, {
              key: 0,
              onClick: _ctx.onAddImage,
              name: "plus-circle-outline",
              class: "w-5 h-5 mt-10 text-red-lp-2400"
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
})